import { BaseContainerModel } from '../base-container.model';
import {bl_wms_pick_pack_queue_RowInterface, bl_wms_pick_pack_queue_RowClass } from '../../dbschema/index';

export class WMSPickPackQueueContainer extends BaseContainerModel {
    bl_wms_pick_pack_queue: bl_wms_pick_pack_queue_RowInterface = new bl_wms_pick_pack_queue_RowClass();
}
